/**
 * 统一的 extracted_text 全屏编辑器
 *
 * 知识库文件 / 企业附件 / 项目附件共用的编辑弹窗，
 * 消除三处重复的 RichTextEditor 包装逻辑。
 */
import React from 'react';
import RichTextEditor from './RichTextEditor';

interface ImageItem {
  url: string;
  page?: number | null;
  index?: number;
  description?: string;
  file_name?: string;
  file_id?: number;
}

export interface ExtractedTextEditorProps {
  /** 是否显示编辑器 */
  open: boolean;
  /** 文件标题 */
  title: string;
  /** 当前 Markdown 内容 */
  value: string;
  /** 内容变更回调 */
  onChange: (value: string) => void;
  /** 保存回调 */
  onSave: () => void;
  /** 关闭回调 */
  onClose: () => void;
  /** 是否正在加载 */
  loading?: boolean;
  /** 是否正在保存（由 RichTextEditor 内部按钮驱动） */
  saving?: boolean;
  /** 图库图片（知识库编辑器使用） */
  imageGallery?: ImageItem[];
  /** 图片上传回调 */
  onImageUpload?: (file: File) => Promise<string>;
  /** URL 解析器 */
  resolveUrl?: (url: string) => string;
  /** 占位符 */
  placeholder?: string;
}

const ExtractedTextEditor: React.FC<ExtractedTextEditorProps> = ({
  open,
  title,
  value,
  onChange,
  onSave,
  onClose,
  loading = false,
  saving = false,
  imageGallery,
  onImageUpload,
  resolveUrl,
  placeholder = '在此输入 Markdown 内容...',
}) => {
  if (!open) return null;

  // 加载中状态
  if (loading) {
    return (
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
        <div className="bg-white rounded-xl shadow-2xl p-8 flex items-center gap-3">
          <div className="animate-spin rounded-full h-6 w-6 border-2 border-gray-300 border-t-green-500" />
          <span className="text-gray-600">加载中...</span>
        </div>
      </div>
    );
  }

  // 全屏编辑器
  return (
    <RichTextEditor
      value={value}
      onChange={onChange}
      imageGallery={imageGallery}
      onImageUpload={onImageUpload}
      resolveUrl={resolveUrl}
      placeholder={placeholder}
      title={title}
      onSave={onSave}
      onClose={onClose}
    />
  );
};

export default ExtractedTextEditor;
